import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Select, MenuItem } from '@material-ui/core';

import api from '../../api';
import { setErrorMessage } from '../../redux/errors';
import { mapErrorMessage } from '../../utils';

import AddModel from '../AddModel';

import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import { lime } from '@material-ui/core/colors';
import Modal from '../../components/Modal';
import GreenCard from '../../components/GreenCard';

import { setCarInsurance, setValidCar } from '../../redux/carInsurance';

import { useFormik } from 'formik';
import { useGetCarsDataAlphabeticalOrder } from '../../hooks/useCarsData';

const builInitialValues = () => {
  let carInfo = {
    carBrand: '',
  };
  return carInfo;
};

export default function AddBrand(props) {
  const { nextWasRequired, year } = props;

  const [dataAutos, setDataAutos] = useState();

  // Checking car year selected for disabled brand input
  const { yearSelected } = useSelector(({ carInsurance }) => ({
    yearSelected: carInsurance?.userCarInsurance?.carYear,
  }));

  const dispatch = useDispatch();

  const history = useHistory();

  const [open, setOpen] = useState(false);

  const onClick = () => {
    setOpen(true);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  const renderModal = () => {
    return <GreenCard closeModal={closeModal} />;
  };

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carBrand: carInsurance.userCarInsurance.carBrand,
    carYear: carInsurance.userCarInsurance.carYear,
  }));

  const initialValues = builInitialValues(userCarInsurance);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,
  });

  // useEffect(() => {
  //   const validationErrors = Object.keys(errors).length > 0;
  //   const valuesRequired = values.carBrand && true;

  //   if (!validationErrors && valuesRequired) {
  //     dispatch(setValidCar({ isValid: true }));
  //   }
  //   if (validationErrors || !valuesRequired) {
  //     dispatch(setValidCar({ isValid: false }));
  //   }
  // }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  function handleChange(e) {
    dispatch(setCarInsurance({ carModel: '' }));
    values.carModel = '';

    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));

    let carBrandName = dataAutos.vehicleBrand.find(
      (e) => e.vehicleBrandId === value
    ).description;
    dispatch(setCarInsurance({ carBrandName: carBrandName }));
  }

  // Function alphabetical sorts the cars data
  const GetCarsDataAlphabeticalOrder = (data) => {
    return useGetCarsDataAlphabeticalOrder({ data, keyProp: 'description'})
  }
  
  useEffect(() => {
    if (year) {
      async function fetchDataAutos() {
        try {
          const { data } = await api.post(
            `/seguros/vehiculo/precio/ch/PDS`,
            {
              generic: {
                infoAutoCode: '',
                listGroups: '',
                listModels: '',
                productionYear: year,
              },
              vehicleBrand: {
                vehicleBrandId: '',
              },
              vehicleGroup: {
                vehicleGroupId: '',
              },
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          
          dispatch(
            setCarInsurance({
              carBrand: null,
              carModel: null,
              carVersion: null,
            })
          );
          
          setDataAutos(null);
          values.carModel = '';
          values.carBrand = '';
          values.carModel = '';
          
          setDataAutos(GetCarsDataAlphabeticalOrder(data));
          
        } catch (error) {
          dispatch(setErrorMessage(mapErrorMessage('systemError')));
          history.push(`/error`);
        }
      }

      fetchDataAutos();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [year]);

  const { token } = useSelector(({ auth }) => ({
    token: auth.token,
  }));

  return (
    <>
      {open && <Modal>{renderModal()}</Modal>}
      <div className='input-field col s10 l4'>
        <Select
          defaultValue=''
          value={values.carBrand}
          id='carBrand'
          name='carBrand'
          type='text'
          className={`validate inputField ${
            hasError('carBrand', values.carBrand) ? 'error' : ''
          }`}
          classes={{ root: 'menuSelect', icon: 'caret' }}
          inputProps={{
            classes: {
              icon: 'caret',
            },
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={ dataAutos && yearSelected ? false : true }
        >
          {dataAutos != null ? (
            dataAutos.vehicleBrand.map((item, key) => {
              return (
                <MenuItem key={key} value={item.vehicleBrandId}>
                  {item.description}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem></MenuItem>
          )}
        </Select>
        <span htmlFor='carBrand'>Marca</span>
        <p className='error-text error-selected'>
          {hasError('carBrand', values.carBrand) && error}
        </p>
      </div>
      <div className='col s2 l2 icon-help'>
        <div onClick={onClick}>
          <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
        </div>
      </div>

      <AddModel
        nextWasRequired={nextWasRequired}
        brandId={userCarInsurance.carBrand !== '' && userCarInsurance.carBrand}
        dataAutos={dataAutos}
      />
    </>
  );
}
